/** Forget's confirmation, from a wall card's ⋯ or the pocket's thing level: deletes the thing with its facts. */
import { useState } from "react";
import { ConfirmDialog } from "@/components/ui";
import { dropWallNewThing } from "@/components/wall/use-wall-new-items";
import { useT } from "@/i18n";
import { framesMemoryMessages } from "@/i18n/messages/frames-memory";
import { useMemoryStore } from "@/stores/memory-store";

export function ForgetThingDialog({
  thingId,
  name,
  onClose,
  testId,
}: {
  thingId: string;
  name: string;
  onClose: () => void;
  testId: string;
}) {
  const t = useT(framesMemoryMessages);
  const [busy, setBusy] = useState(false);
  const forget = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await useMemoryStore.getState().forgetThing(thingId);
    } catch {
      // The request's toast says why; the thing stays.
      setBusy(false);
      onClose();
      return;
    }
    onClose();
    dropWallNewThing(thingId);
  };
  return (
    <ConfirmDialog
      busy={busy}
      title={t("forgetTitle", { name })}
      description={t("forgetDescription", { name })}
      confirmLabel={busy ? t("forgetting") : t("forget")}
      onConfirm={() => void forget()}
      onCancel={() => {
        if (!busy) onClose();
      }}
      data-testid={testId}
    />
  );
}
